import { Component, OnInit, Input } from '@angular/core';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { Progress                 } from 'src/app/beans/progress_mode/progress_mode.progress';
import { Device                   } from 'src/app/beans/device/device.bean';
import { Site                     } from 'src/app/beans/site/site.bean';

@Component
({
  selector: 'device-service-checkbox',
  templateUrl: './device.service.checkbox.html',
  styleUrls: ['./device.service.checkbox.scss']
})

export class DeviceServiceCheckbox implements OnInit
{
  checked = false

  private deviceId: number
  private siteId  : number

  @Input('device') set _device( device: Device )
  {
    if( device )
    {
      this.deviceId = device.id
      this.init()
    }
  }

  @Input('site') set _site( site: Site )
  {
    if( site )
    {
      this.siteId = site.id
      this.init()
    }
  }

  values      : Progress[] = []
  currentValue: Progress

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  //----------------------------------------------------------------------------------------

  ngOnInit() {}

  async init()
  {
    this.values = []
    if( this.siteId && this.deviceId )
    {
      await this.retriveValues( this.siteId, this.deviceId )
    }
  }

  //----------------------------------------------------------------------------------------

  getSelectedValue()
  {
    return this.currentValue
  }

  setSelectedValue(value: Progress): void
  {
    this.currentValue = value
  }

  clearSelectedValue(): void
  {
    this.currentValue = undefined
  }

  //----------------------------------------------------------------------------------------

  async change(event: any, service: Progress )
  {
    console.log(service, event)
    await this.updateCounterService( this.siteId, service.id, this.deviceId, event.checked)
  }

  //----------------------------------------------------------------------------------------

  async retriveValues( siteId: number, deviceId: number )
  {
    const user = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect

    this._loader.start()

    let response = await this._handler.device().getDeviceService( (user as User).token, siteId, deviceId)

    this._loader.stop()

    if (!response) return

    const list = ( response as any ).list as Progress[]

    console.log(list);

    this.values = list

    return list
  }

  async updateCounterService( siteId: number, serviceId: number, deviceId: number, set: boolean)
  {
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return // TODO handle user incorrect

    this._loader.start()

    let response = null
    if(set === true) response = await this._handler.device().updateDeviceService( (user as User).token, siteId, serviceId, deviceId, 1 )
    else             response = await this._handler.device().updateDeviceService( (user as User).token, siteId, serviceId, deviceId, 0 )

    this._loader.stop()

    if (!response) return

    this.init()
  }

  async selectAll(value: number){
    this._loader.start()
    const user  = this._session.user().get()
    if ( !User.isKind(user) ) return

    const promises = []

    this.values.forEach(element => {
      if(element.enabled !== value)
        promises.push(this._handler.device().updateDeviceService( (user as User).token, this.siteId, element.id, this.deviceId, value))
    });

    await Promise.all(promises)
    this._loader.stop()

    this.init()
  }

  //----------------------------------------------------------------------------------------
}
